// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Wars Universe - Warp Gates Configuration
 */

export const warpGates = [
  {
    id: 'gate-starwars-masseffect',
    name: 'Hyperspace Relay',
    type: 'warpgate',
    distance: 25,
    fromUniverse: 'starwars',
    destinationUniverse: 'masseffect',
    fromSystem: 800,
    toSystem: 900,
    destinationGate: 'gate-masseffect-starwars',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'MODERATE',
    resources: 'GATEWAY',
    services: [],
    primaryColor: '#FFE81F',
    secondaryColor: '#00d4ff',
    hasRings: true,
    discovered: false,
    description: 'Hyperspace corridor intersects with mass relay network. Ancient technology convergence. The Force and Element Zero interact strangely.',
    scanDescription: 'ANALYSIS: Hyperspace-mass relay hybrid detected. Destination: The Citadel. Force energy + eezo fields. May the Force be with you. Gate travel does not consume fuel.'
  }
];

export const warpGatePositions = {
  'gate-starwars-masseffect': { x: 42, y: 58, z: -5 }
};

const starwarsGates = { warpGates, warpGatePositions };
export default starwarsGates;
